import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	geoblock_groups: [],
	isLoaded: true,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR MAIN_ITEM STATE ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// ****************** FETCH GEOBLOCK_GROUPS_ITEM ******************
			case types.FETCH_PRODUCT_GEOBLOCK_GROUPS_LOADING:
				draft.isLoaded = false;
				return;

			case types.FETCH_PRODUCT_GEOBLOCK_GROUPS_SUCCESS:
				draft.geoblock_groups = action.payload;
				draft.isLoaded = true;
				return;

			case types.FETCH_PRODUCT_GEOBLOCK_GROUPS_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				return;

			default:
				return state;
		}
	});
